/* eslint-disable camelcase */
import { TYPE } from '@/constants';
import Model from '../model';
import CircleGA from './circle';
import RectangularGA from './rect';
import PolygonalGA from './polygon';

export const mappings = {
  [TYPE.GA_POLYGONAL]: PolygonalGA,
  [TYPE.GA_RECTANGULAR]: RectangularGA,
  [TYPE.GA_ROUNDED]: CircleGA,
};

export const shapeMappings = {
  [TYPE.CIRCLE]: TYPE.GA_ROUNDED,
  [TYPE.RECT]: TYPE.GA_RECTANGULAR,
  [TYPE.POLYGON]: TYPE.GA_POLYGONAL,
};

export class GAHelper {
  static create(type, params) {
    return mappings[shapeMappings[type]].create(params);
  }

  static clone(unit, options) {
    const { keepPosition } = options;
    const json = unit.toJSON();
    if (!keepPosition) {
      if (unit.subtype === TYPE.GA_POLYGONAL) {
        json.attributes.transform.e += 50;
        json.attributes.transform.f += 50;
      } else {
        json.attributes.position[0] += 50;
        json.attributes.position[1] += 50;
      }
    }
    json.uuid = Model.getUniqueIdStatic(json.type);
    return mappings[unit.subtype].fromJSON(json);
  }

  static fromJSON(params) {
    return mappings[params.subtype].create(params);
  }
}
